import { Api } from '../api/root-api';
import {
  createZoFilePrefixRequest,
  createZoFilePrefixResponse,
  DocumentPreviewRequest,
  DocumentPreviewResponse,
  embedFilesRequest,
  embedFilesResponse,
  GetIndexingStatusRequest,
  GetIndexingStatusResponse,
  ListZoFilePrefixRequest,
  ListZoFilePrefixResponse,
  updateZoFileRequest,
  updateZoFileResponse,
} from './model';

export const ListZoFilePrefixes = Api.injectEndpoints({
  endpoints: (builder) => ({
    listZoFilePrefixes: builder.mutation<
      ListZoFilePrefixResponse,
      ListZoFilePrefixRequest
    >({
      query(args) {
        return {
          url: `hub/orgs/api/docs/zo-file/list/${args.params.sellerWorkspaceId}`,
          method: 'POST',
          params: args.params,
          body: args.body,
        };
      },
    }),
    createZoFileObjects: builder.mutation<
      createZoFilePrefixResponse,
      createZoFilePrefixRequest
    >({
      query(args) {
        return {
          url: `hub/orgs/api/docs/zo-file/create/${args.params.sellerWorkspaceId}`,
          method: 'POST',
          params: args.params,
          body: args.body,
        };
      },
      invalidatesTags: (result, error, arg) => [
        { type: 'FileList', id: `${arg.params.sellerWorkspaceId}-knowledge` },
      ],
    }),
    updateZoFileObjects: builder.mutation<
      updateZoFileResponse,
      updateZoFileRequest
    >({
      query(args) {
        return {
          url: `hub/orgs/api/docs/zo-file/file-operations/${args.params.sellerWorkspaceId}`,
          method: 'POST',
          params: args.params,
          body: args.body,
        };
      },
      invalidatesTags: (result, error, arg) => [
        {
          type: 'FileList',
          id: `${arg.params.sellerWorkspaceId}-${arg.body.request[0]?.documentType}`,
        },
      ],
    }),
    embedFile: builder.mutation<embedFilesResponse, embedFilesRequest>({
      query(args) {
        return {
          url: 'hub/bot/api/v1/embed-files',
          method: 'POST',
          params: args.params,
          body: { files: args.files },
        };
      },
    }),
    getIndexingStatus: builder.mutation<
      GetIndexingStatusResponse,
      GetIndexingStatusRequest
    >({
      query(args) {
        return {
          url: `/hub/orgs/api/docs/files/${args.params.sellerWorkspaceId}`,
          method: 'POST',
          params: args.params,
          body: args.body,
        };
      },
    }),
    previewDocument: builder.mutation<
      DocumentPreviewResponse,
      DocumentPreviewRequest
    >({
      query(args) {
        return {
          url: `/invoiceservice/documents/preview/${args.params.workspaceId}?sellerWorkspaceId=${args.params.workspaceId}`,
          method: 'POST',
          body: args.body,
        };
      },
    }),
  }),
});

export const {
  useListZoFilePrefixesMutation,
  useCreateZoFileObjectsMutation,
  useUpdateZoFileObjectsMutation,
  useEmbedFileMutation,
  useGetIndexingStatusMutation,
  usePreviewDocumentMutation,
} = ListZoFilePrefixes;
